import React, { useState } from 'react';

const TextQrCode = ({ setQrData }) => {
    const [text, setText] = useState('');
    const maxLength = 1000; // Limite para modo alfanumérico com correção de erro H
    const placeholder = "Digite seu texto";

    const handleTextChange = (e) => {
        const newText = e.target.value;
        if (newText.length <= maxLength) {
            setText(newText);
            setQrData(newText);
        }
        if(newText.length > maxLength) {
            setText(newText.substring(0, maxLength));
            setQrData(newText.substring(0, maxLength));
        }
        if(newText.length === 0) {
            setQrData(placeholder);
        }
    };

    const handleBlur = () => {
        if (text.trim() === '') {
            setText(placeholder);
            setQrData(placeholder);
        }
    };

    const handleFocus = () => {
        if (text === placeholder) {
            setText('');
            setQrData('');
        }
    };

    return (
        <div className="text-qr-code">
            <textarea
                id="qr-data"
                placeholder={placeholder}
                value={text}
                onChange={handleTextChange}
                onBlur={handleBlur}
                onFocus={handleFocus}
                maxLength={maxLength}
                rows="10"
                cols="50"
            />
            <div className="char-count">
                {maxLength - text.length} caracteres restantes
            </div>
        </div>
    );
};

export default TextQrCode;